module.exports = __webpack_public_path__ + "static/media/slider_arrow_left.7409d977.svg";